<template>
  <b-tabs>
    <b-tab title="Componentes" active>
      <b-row>
        <b-col sm="12"
               md="10"
               lg="10"
               />
        <b-col sm="12"
               md="2"
               lg="2"
        >
          <b-button variant="primary"
                    size="sm"
                    style="display: block; margin: auto; margin-bottom: 1em;"
                    @click="formCrearValoresExposicion()"
          >
            <i class="fa fa-plus"></i> Nuevo
          </b-button>
        </b-col>
      </b-row>
      <!-- TABLA DE COMPONENTES -->
      <b-table responsive
               small
               thead-class="table-active"
               :items="valores_exposicion"
               :fields="columnas"
      >
        <template v-slot:cell(compuesto)="row">
          {{ row.item.componente }}
        </template>
        <template v-slot:cell(twa_acgih)="row">
          {{ row.item.twa_acgih }}
        </template>
        <template v-slot:cell(stel_acgih)="row">
          {{ row.item.stel_acgih }}
        </template>
        <template v-if="!disabledActions" v-slot:cell(action)="row">
          <el-tooltip
            content="Editar Componente"
            placement="top"
            effect="light"
          >
            <b-button
              size="sm"
              class="mr-1 mt-1"
              variant="primary"
              @click.prevent="editarValorExpo(row.item)"
            ><i class="el-icon-edit"></i
            ></b-button>
          </el-tooltip>
          <el-tooltip
            content="Eliminar Componente"
            placement="top"
            effect="light"
          >
            <b-button
              size="sm"
              class="mr-1 mt-1"
              variant="danger"
              @click.prevent="eliminarValorExpo(row.item)"
            ><i class="el-icon-delete"></i
            ></b-button>
          </el-tooltip>
        </template>
      </b-table>
      <b-modal id="form-valores-exposicion"
               v-model="form_valores_exposicion"
               :title="(selectedValorExpo.accion === 'crear' ? 'Crear' : 'Editar') + ' valor de exposición'"
               size="lg"
      >
        <ModalFormValoresExposicion />
        <template #modal-footer="{ cancel }">
          <b-button size="sm" variant="primary" @click="guardarValoresExposicion()">
            Guardar
          </b-button>
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancelar
          </b-button>
        </template>
      </b-modal>
    </b-tab>
    <b-tab title="Otros" @click="getOtrosValoresExposicion()">
      <b-form @submit.prevent="guardarOtrosValoresExposicion()">
        <b-row>
          <b-form-group class="col-12">
            <label for="componentes">Componentes  <span style="color: red">(*)</span></label>
            <b-form-textarea
              name="componentes"
              v-model="selectedValorExpoOtros.componentes"
              required
            >
            </b-form-textarea>
          </b-form-group>
          <b-form-group class="col-12">
            <label for="otros_tlv">Otros TLV  <span style="color: red">(*)</span></label>
            <b-form-textarea
              name="otros_tlv"
              v-model="selectedValorExpoOtros.otros_tlv"
              required
            >
            </b-form-textarea>
          </b-form-group>
        </b-row>
        <b-row class="mt-0">
          <b-col sm="4">
            <b-button
              type="submit"
              size="sm"
              class="mb-2"
              style="width: 200px !important;"
              variant="primary"
              :disabled="disabledActions"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-tab>
  </b-tabs>
</template>

<script>
import Swal from "sweetalert2";
import {mapActions, mapMutations, mapState} from "vuex";
import ModalFormValoresExposicion from "./ModalFormValoresExposicion";

export default {
  name: "ModalValoresExposicion",
  components: {
    ModalFormValoresExposicion,
  },
  data() {
    return {
      disabledActions: false,
      form_valores_exposicion: false,
      columnas: [
        {
          key: "componente",
          label: "Componente",
          thStyle: {
            "min-width": "100px !important",
            width: "150px !important",
          },
        },
        {
          key: "twa_acgih",
          label: "TWA (ACGIH)",
          thStyle: {
            "min-width": "125px !important",
            width: "125px !important",
          },
        },
        {
          key: "stel_acgih",
          label: "STEL (ACGIH)",
          thStyle: {
            "min-width": "125px !important",
            width: "125px !important",
          },
        },
        {
          key: "action",
          label: "",
          thStyle: {
            "min-width": "80px !important",
            width: "80px !important",
          },
        },
      ],
    }
  },
  async created() {
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      this.setIdFdsProducto(this.$route.params.id_fds_producto);
    }
  },
  methods: {
    formCrearValoresExposicion() {
      this.resetSelectedValorExpo();
      this.form_valores_exposicion = true;
    },
    async guardarValoresExposicion() {
      if (this.selectedValorExpo.accion === 'crear') {
        await this.crearValoresExposicion();
      } else if (this.selectedValorExpo.accion === 'editar') {
        await this.actualizarValoresExposicion();
      }
      this.form_valores_exposicion = false;
    },
    editarValorExpo(item) {
      this.resetSelectedValorExpo();
      let itemEditar = {
        accion: 'editar',
        id: item.id,
        id_empresa: item.id_empresa,
        id_fds_producto: item.id_fds_producto,
        componente: item.componente,
        twa_acgih_rango: item.twa_acgih_rango,
        twa_acgih: item.twa_acgih,
        twa_acgih_hasta: item.twa_acgih_hasta,
        id_um_twa_acgih: item.id_um_twa_acgih,
        twa_acgih_observacion: item.twa_acgih_observacion,
        stel_acgih_rango: item.stel_acgih_rango,
        stel_acgih: item.stel_acgih,
        stel_acgih_hasta: item.stel_acgih_hasta,
        id_um_stel_acgih: item.id_um_stel_acgih,
        stel_acgih_observacion: item.stel_acgih_observacion,
      };
      this.setSelectedValorExpo(itemEditar);
      this.form_valores_exposicion = true;
    },
    eliminarValorExpo(item) {
      let confirm = false;
      Swal.fire({
        text: "¿Desea eliminar el componente?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#097b83',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.borrarValoresExposicion(item);
          await this.getValoresExposicion();
        }
      });
    },
    async guardarOtrosValoresExposicion() {
      if (this.selectedValorExpoOtros.accion === 'crear') {
        await this.crearOtrosValoresExposicion();
      } else if (this.selectedValorExpoOtros.accion === 'editar') {
        await this.actualizarOtrosValoresExposicion();
      }
    },
    ...mapMutations('fds_productos', [
      'setIdEmpresaFdsProducto',
      'setIdFdsProducto',
      'resetSelectedValorExpo',
      'setSelectedValorExpo',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getValoresExposicion',
      'crearValoresExposicion',
      'actualizarValoresExposicion',
      'borrarValoresExposicion',
      'getOtrosValoresExposicion',
      'crearOtrosValoresExposicion',
      'actualizarOtrosValoresExposicion',
    ])
  },
  computed: {
    ...mapState('fds_productos', [
      'selectedValorExpo',
      'valores_exposicion',
      'id_empresa',
      'id_fds_producto',
      'valores_exposicion',
      'selectedValorExpoOtros',
    ])
  }
}
</script>

<style scoped>

</style>
